export { default } from './assignIn'



//////////////////
// WEBPACK FOOTER
// ../ckeditor5-utils/src/lib/lodash/extend.js
// module id = null
// module chunks = 